import { layerGroup } from 'leaflet'

export const groupConcessionLayers = layerGroup([])
